import firebase from '@/firebase/firebase.js'

const firestore = firebase.firestore()

export default firestore
